type DownyMildewTelemetryPrimitive = string | number | boolean;
export type DownyMildewTelemetryProperties = Record<string, DownyMildewTelemetryPrimitive>;

const downyMildewIdentifier = 'MyArable.DownyMildew';
const mobileMaxWidthPx = 960;

export const DownyMildewAIIdentifiers = {
  pageViewed: `${downyMildewIdentifier}.PageViewed`,
  tabSelected: `${downyMildewIdentifier}.Tab.Selected`,
  overviewPageViewed: `${downyMildewIdentifier}.Overview.PageViewed`,
  overviewRecalculateAllClicked: `${downyMildewIdentifier}.Overview.RecalculateAll.Clicked`,
  overviewCropFieldCheckboxChanged: `${downyMildewIdentifier}.Overview.CropField.Checkbox.Changed`,
  overviewCropFieldFilterChanged: `${downyMildewIdentifier}.Overview.CropField.Filter.Changed`,
  overviewActionMenuOpened: `${downyMildewIdentifier}.Overview.ActionMenu.Opened`,
  overviewActionMenuItemSelected: `${downyMildewIdentifier}.Overview.ActionMenu.ItemSelected`,
  overviewSortChanged: `${downyMildewIdentifier}.Overview.Sort.Changed`,
  overviewDateNavigationClicked: `${downyMildewIdentifier}.Overview.DateNavigation.Clicked`,
  overviewAdviceCellOpened: `${downyMildewIdentifier}.Overview.AdviceCell.Opened`,
  insightsPageViewed: `${downyMildewIdentifier}.Insights.PageViewed`,
  insightsCropFieldSelected: `${downyMildewIdentifier}.Insights.CropField.Selected`,
  insightsCalculateClicked: `${downyMildewIdentifier}.Insights.Calculate.Clicked`,
  insightsGraphSeriesToggled: `${downyMildewIdentifier}.Insights.GraphSeries.Toggled`,
  insightsActionMenuOpened: `${downyMildewIdentifier}.Insights.ActionMenu.Opened`,
  insightsActionMenuItemSelected: `${downyMildewIdentifier}.Insights.ActionMenu.ItemSelected`,

  // Legacy identifiers kept for existing dashboards/flows that are outside this story scope.
  viewAdvice: `${downyMildewIdentifier}.ViewAdvice`,
  recalc: `${downyMildewIdentifier}.Recalculate`,
  addActionMyArable: `${downyMildewIdentifier}.AddAction`,
  selectPreventive: `${downyMildewIdentifier}.ActionMenu.Preventive.Selected`,
  selectCurative: `${downyMildewIdentifier}.ActionMenu.Curative.Selected`,
  selectStop: `${downyMildewIdentifier}.ActionMenu.Stop.Selected`,
  selectIrrigation: `${downyMildewIdentifier}.ActionMenu.Irrigation.Selected`,
  selectGrowthStage: `${downyMildewIdentifier}.ActionMenu.GrowthStage.Selected`,
  selectObservation: `${downyMildewIdentifier}.ActionMenu.Observation.Selected`,
  submitGrowthStage: `${downyMildewIdentifier}.GrowthStage.Submitted`,
  submitObservation: `${downyMildewIdentifier}.Observation.Submitted`,
  clickTable: `${downyMildewIdentifier}.Tab.Overview.Selected`,
  clickInsights: `${downyMildewIdentifier}.Tab.Insights.Selected`,
} as const;

const getDevice = (): 'mobile' | 'desktop' => {
  const browserWindow = globalThis.window;

  if (!browserWindow) {
    return 'desktop';
  }

  if (typeof browserWindow.matchMedia === 'function') {
    return browserWindow.matchMedia(`(max-width: ${mobileMaxWidthPx}px)`).matches ? 'mobile' : 'desktop';
  }

  return browserWindow.innerWidth <= mobileMaxWidthPx ? 'mobile' : 'desktop';
};

export const createDownyMildewTelemetryProperties = (
  action: string,
  extraProperties: DownyMildewTelemetryProperties = {},
): DownyMildewTelemetryProperties => ({
  device: getDevice(),
  role: 'customer',
  action,
  ...extraProperties,
});

export const downyMildewELearningUrl = 'https://share.articulate.com/xxwqcJEBTUMSVP7SPiVgh';
